import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { sdVoteOption, SdVoteId } from '../../../../../shared/constants/sd-ballot.constants';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { ISdConsensusCriteria } from '../../../shared/models/sd/sd-consensus-criteria';

@Component({
    selector: 'app-sd-consensus-criteria',
    templateUrl: './sd-consensus-criteria.component.html',
    styleUrl: './sd-consensus-criteria.component.scss',
    standalone: false
})
export class SdConsensusCriteriaComponent {
  @Input() data: IDonutChartItem[] = [];
  @Output() onConsensusChanged = new EventEmitter<ISdConsensusCriteria>();

  agreeLabel = sdVoteOption[SdVoteId.VT_AGREE].text;
  noResponseLabel = sdVoteOption[SdVoteId.VT_NONE].text;

  isShowHelpForSimpleMajority: boolean = false;
  hasMetSimpleMajorityConsensus: boolean = false;

  isShowHelpForFullConsensus: boolean = false;
  hasMetForFullConsensus: boolean = false;

  constructor() {}

  ngOnInit() {
    if (this.data && this.data.length > 0) this.calculateConsensus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue && !changes['data'].firstChange) {
      this.data = changes['data'].currentValue
      if (this.data && this.data.length > 0) {
        this.calculateConsensus();
      }
    }
  }

  openHelpModalForSimpleMajority() {
    this.isShowHelpForSimpleMajority = true;
  }

  closeHelpModalForSimpleMajority() {
    this.isShowHelpForSimpleMajority = false;
  }

  openHelpModalForFullConsensus() {
    this.isShowHelpForFullConsensus = true;
  }

  closeHelpModalForFullConsensus() {
    this.isShowHelpForFullConsensus = false;
  }

  calculateConsensus() {
    this.calculateSimplyMajorityConsensus();
    this.calculateFullConsensus();

    let consensusResult: ISdConsensusCriteria = {
      hasMetSimpleMajorityConsensus: this.hasMetSimpleMajorityConsensus,
      hasMetFullConsensus: this.hasMetForFullConsensus
    };

    this.onConsensusChanged.emit(consensusResult);
  }

  calculateSimplyMajorityConsensus() {
    let totalVotes = this.data;
    let totalPercentages = this.calculatePercentages(totalVotes);



    const maxPercentage = Math.max(...totalPercentages.filter(item => item.label == this.agreeLabel).map(item => item.percentage || 0));

    this.hasMetSimpleMajorityConsensus = maxPercentage >= 67;
  }

  calculateFullConsensus() {
    let totalReceivedVotes = this.data.filter(item => item.label !== this.noResponseLabel);
    let totalPercentages = this.calculatePercentages(totalReceivedVotes);

    const maxPercentage = Math.max(...totalPercentages.filter(item => item.label == this.agreeLabel).map(item => item.percentage || 0));
    const roundedPercentage = Math.round(maxPercentage);

    this.hasMetForFullConsensus = roundedPercentage >= 80;

  }

  calculatePercentages(data: IDonutChartItem[]) : IDonutChartItem[] {
    const total = data.reduce((sum, item) => sum + (item.weight ?? 0), 0);
    // Calculate percentage and round

    let percentages = data.map(item => ({
      ...item,
      percentage: total ? ((item.weight??0) / total) * 100 : 0
    }));

    return percentages;
  }

}
